import useGame from "./stores/useGame"

import './style.css'

export default function UI()
{
    
    const infoPanel = useGame((state) => state.infoPanel)
    const play =  useGame((state) => state.play)
    const toggleGas = useGame((state) => state.toggleGas)
    const reset = useGame((state) => state.reset)

        return <>

        <div className='banner-top'>
            <img src="./DSL_Logo_stackedonWHT_Transp_Web_120.png" className="image-wrap" onClick={()=>{window.open('https://www.darkstarlabs.io/')}}></img>
            <div className="action-card-row" onClick={()=>{window.open('https://www.darkstarlabs.io/contact')}}>
                <div className='text-button-row'>Talk to the team</div>
                <div className='dot'>?</div>    
                
            </div> 
        </div> 
            
        
        { play === false && infoPanel === 'null' && <div className='interface'>

        <div className="action-card" onClick={toggleGas}>
            <div className='dot'> + </div> 
            
            <div className='text-button'>Engage</div>
        </div> 



        </div> }

        { play === true && <div className='interface'>

        <div className="action-card" onClick={toggleGas}>
            <div className='dot'> - </div> 
            
            <div className='text-button'>Stop</div>
        </div> 



        </div> }

        <div id="p1" className='p'>
            <div className='heading'>The <span style={{color: '#F2330D'}}>'Feelings'</span> Box</div>
            <div className='body'>Using state of the art artificial out-telligence. If the arm does a boo boo, it feels real sad.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p2" className='p'>
            <div className='heading'>ARSE <span style={{color: '#F2330D'}}>Assisted Rear Stabilisation Engine</span></div>
            <div className='body'>Theres junk in this trunk to help keep the arm balanced on any surface!</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p3" className='p'>
            <div className='heading'><span style={{color: '#F2330D'}}>WIBBLY</span> Turny Bit</div>
            <div className='body'>It's like your wrist or your elbow or something?</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p4" className='p'>
            <div className='heading'>There Are <span style={{color: '#F2330D'}}>Four</span> Lights</div>
            <div className='body'>These FOUR lights represent the charge level of the onboard VIBE battery.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p5" className='p'>
            <div className='heading'>Mien <span style={{color: '#F2330D'}}>Grabba</span></div>
            <div className='body'>Can literally pick up anything you give it provided it's a 10cm cube.</div>    
            <div className='body'><span style={{color: '#F2330D'}}>Don't feed after midnight or before 6am.</span></div>    

            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p6" className='p'>
            <div className='heading'>VIBE<span style={{color: '#F2330D'}}> Volatile Inverse Battery Engine</span></div>
            <div className='body'>Located at the tip of the track shaft, it can power the ARM for up to an hour if DC power is lost.</div>
            <div className='body'>Hot dang it's hot swappable!</div>

            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

        <div id="p7" className='p'>
            <div className='heading'>Base</div>
            <div className='body'>It's big, it's heavy, the ARM gets its feelings get hurt if you mention it.</div>
            <div className='reset' onClick={() => {reset()}}>BACK</div>
        </div> 

    </>
}





